import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Renderer, EventEmitter, Output } from '@angular/core'
import { PreguntaService } from '../servicios/preguntas.service'
import { PreguntaPrimerNivel } from '../dominio/pregunta-primer-nivel'
import { DeclaracionService } from '../servicios/declaracion.service'
import { Prospecto, Ocupacion } from '../dominio/prospecto'
import { Declaracion } from '../dominio/declaracion'
import { RespuestaPrimerNivel } from '../dominio/respuesta-primer-nivel'
import { Router, ActivatedRoute, Params } from '@angular/router'
import { Polymer, PolymerChanges, OnPolymerChange } from '@codebakery/origami'
import { PreguntaSecundaria } from 'app/dominio/pregunta-secundaria'
import { RespuestaService } from '../servicios/respuesta.service'

@Component({
  selector: 'app-declaracion-asegurabilidad',
  templateUrl: './declaracion.component.html'
})
export class DeclaracionComponent implements OnInit, OnPolymerChange  {

  idSolicitud: string
  dni: string
  prospecto = new Prospecto('', 0, 0, '', new Ocupacion('', '', []), 0, 0)
  declaracion = new Declaracion(this.idSolicitud, this.prospecto, [], [], [], '', '', '', '', 0,'')
  @PolymerChanges() preguntas: PreguntaPrimerNivel[] = []
  @ViewChild('declaracionC') dc: ElementRef
  title = 'Declaración de asegurabilidad'
  image = '../../assets/images/img-card-declaracion-aseg.png'

  constructor(
    private preguntaService: PreguntaService,
    private declaracionService: DeclaracionService,
    private activatedRoute: ActivatedRoute,
    private changeRef: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer,
    private respuestaService: RespuestaService
  ) {
    renderer.listenGlobal('document', 'solicitarPreguntaSecundaria', event => {
      // TODO: Estos nombres de eventos deberían estar centralizados (es muy facil hacer un Typo)
      this.psDesdeRespuestaPrimerNivel(event.detail.id, event.detail.indicePregunta, event.detail.indiceRespuesta)
    })

    renderer.listenGlobal('document', 'solicitarPreguntaSecundariaAutoCompletar', event => {
      this.psDesdeRespuestaPrimerNivelAutoCompletar(event.detail.id)
    })

    renderer.listenGlobal('document', 'solicitarSiguientePreguntaSecundariaTs', event => {
      this.psSiguiente(event.detail.id,
        event.detail.indicePregunta,
        event.detail.indiceRespuesta,
        event.detail.indicePreguntaSecundaria,
        event.detail.idRespuestaPrimerNivel,
        event.detail.textoRespuesta)
    })

    renderer.listenGlobal('document', 'evaluarDeclaracion', this.manejarEvaluarDeclaracion.bind(this))

    renderer.listenGlobal('document', 'solicitarRespuestasAutoCompletar', event => {
      this.solicitarRespuestasAutoCompletar(event.detail.id)
    })

    renderer.listenGlobal('document', 'agregarRespuestaPrimerNivelPregunta', event => {
      this.agregarRespuestaPrimerNivelPregunta(event.detail.id, event.detail.texto, event.detail.indice)
    })
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe( (params: Params) => {
      this.idSolicitud = params.idSolicitud
      this.dni = params.dni
      this.declaracionService
        .obtenerDeclaracion(this.idSolicitud, this.dni)
        .subscribe(
          declaracion => {
            if (declaracion.preguntasPrimerNivel && declaracion.prospecto) {
              this.declaracion = declaracion
              this.preguntas = declaracion.preguntasPrimerNivel
              this.prospecto = declaracion.prospecto
              // Si la declaración trae conclusiones ya, es porque fue evaluada y ya se puede
              // considerar que se terminó de responder.
              if (declaracion.conclusiones.length > 0) {
                this.preguntas.forEach(p =>
                  p.respuestas.forEach(r => r.finalizada = true)
                )
              }
            }
          },
          e => console.error(e)
        )
    })
  }

  onPolymerChange() {
    this.changeRef.detectChanges()
  }

  manejarEvaluarDeclaracion() {
    if (this.declaracion.conclusiones.length === 0) this.enviarDeclaracion()
    else this.mostrarResultado(this.declaracion.conclusiones)
  }

  enviarDeclaracion() {
    if (this.declaracionService.verificarPreguntas(this.preguntas)) {
      const ps = this.preguntas.map( p =>
        p.respuestas.map(r =>
          r.preguntasSecundarias.map(preSec => this.preguntaService.construirPreguntaSecundariaD(preSec))
        )
      )
      const preguntas = this.preguntas.reduce<PreguntaPrimerNivel[]>( (pps, pp) => {
        const respuestasSeleccionadas: RespuestaPrimerNivel[] = pp.respuestas.reduce<RespuestaPrimerNivel[]>( (rs, r) => {
          if (r.seleccionada) rs.push(r)
          return rs
        }, [])
        pp.respuestas = respuestasSeleccionadas
        pps.push(pp)
        return pps
      }, [])
      const preguntasSecundarias = this.flattenPreguntaSecundarias(ps)
      const declaracion = new Declaracion(
        this.idSolicitud,
        this.prospecto,
        preguntas,
        preguntasSecundarias,
        [],
        Date.now().toString(),
        this.declaracion.ramo,
        this.declaracion.subRamo,
        this.declaracion.canal,
        this.declaracion.deltaPeso,
        this.declaracion.nomOcupacion
      )
      this.declaracionService
        .enviarDeclaracion(declaracion)
        .then(res => this.mostrarResultado(res))
    }
  }

  flattenPreguntaSecundarias(preguntas) {
    const arr = []
    preguntas.forEach(element => {
      element.forEach(element2 => {
        element2.forEach(element3 => {
          arr.push(element3)
        })
      })
    })
    return arr
  }

  mostrarResultado(rep) {
    dispatchEvent(new CustomEvent('mostrarResultado', {detail: {respuesta: rep}}))
  }

  psDesdeRespuestaPrimerNivel(res: string, indicePre, indiceRes): any {
    const declaracion = new Declaracion(
      this.idSolicitud,
      this.prospecto,
      this.preguntas,
      [],
      [],
      Date.now().toString(),
      this.declaracion.ramo,
      this.declaracion.subRamo,
      this.declaracion.canal,
      this.declaracion.deltaPeso,
      this.declaracion.nomOcupacion
    )
    this.preguntaService.obtenerPreguntaSecundariaDeRespuestaPrimerNivel(res, declaracion)
      .subscribe(
        ps => {
          if (ps !== null) {
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias.push(ps)
            const campo = `preguntasPrimerNivel.${indicePre}.respuestas.${indiceRes}.preguntasSecundarias`
            const evento = [{ index: 3, addedCount: 1, removed: [], object: this.preguntas, type: 'splice' }]
            this.dc.nativeElement.notifySplices(campo, evento)
          }
        },
        e => dispatchEvent(new CustomEvent('cerrarRespuesta', {detail: {idRespuesta: res, sinCollage: true}}))
      )
  }

  psDesdeRespuestaPrimerNivelAutoCompletar(id: string) {
    const declaracion = new Declaracion(
      this.idSolicitud,
      this.prospecto,
      this.preguntas,
      [],
      [],
      Date.now().toString(),
      this.declaracion.ramo,
      this.declaracion.subRamo,
      this.declaracion.canal,
      this.declaracion.deltaPeso,
      this.declaracion.nomOcupacion
    )
    this.preguntaService.obtenerPreguntaSecundariaDeRespuestaPrimerNivel(id, declaracion)
      .subscribe(
        ps => {
          dispatchEvent(new CustomEvent('respuestaPreguntaSecundariaAutoCompletar', {detail: {id: id, preguntaSecundaria: ps}}))
        },
        e => dispatchEvent(new CustomEvent('mostrarError', {detail: {error: e}}))
      )
  }

  psSiguiente(res: string, indicePre: number, indiceRes: number, indicePS: number, idRespuestaPrimerNivel: string, textoRespuesta: string) {

    this.preguntaService.obtenerPreguntaSecundariaSiguiente(res).subscribe(
      ps => {
        const campoBase = `preguntasPrimerNivel.${indicePre}.respuestas.${indiceRes}.preguntasSecundarias`
        const campoRespuestaSeleccionada = `${campoBase}.${indicePS}.textoRespuestaSeleccionada`
        const evento = [{
          object: this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias[indicePS].textoRespuestaSeleccionada,
          type: 'splice'
        }]
        switch (ps.tipo) {
          case 'Conclusion':
            this.preguntas[indicePre].respuestas[indiceRes].finalizada = true
            this.preguntas[indicePre].respuestas[indiceRes].seleccionada = true
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias.splice(indicePS + 1)
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias[indicePS].respuestaSeleccionada = res
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias[indicePS].textoRespuestaSeleccionada = textoRespuesta
            this.dc.nativeElement.notifySplices(campoBase, [{ object: this.preguntas, type: 'splice' }])
            this.dc.nativeElement.notifySplices(campoRespuestaSeleccionada, evento)

            dispatchEvent(new CustomEvent('cerrarRespuesta', {detail: {idRespuesta: idRespuestaPrimerNivel}}))
            break
          case undefined :
            this.preguntas[indicePre].respuestas[indiceRes].finalizada = false
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias.splice(indicePS + 1)
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias[indicePS].respuestaSeleccionada = res
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias[indicePS].textoRespuestaSeleccionada = textoRespuesta
            this.preguntas[indicePre].respuestas[indiceRes].preguntasSecundarias.push(ps)
            this.dc.nativeElement.notifySplices(campoBase, [{ object: this.preguntas, type: 'splice' }])
            this.dc.nativeElement.notifySplices(campoRespuestaSeleccionada, evento)
            break
        }
      },
      e => {
        // TODO: ¿Qué hacemos acá?
      }
    )
  }

  solicitarRespuestasAutoCompletar(id: string) {
    this.respuestaService.obtenerRespuestasTextoAbierto(id).subscribe(p => {
        return dispatchEvent(new CustomEvent('responseRespuestaAutoCompletar', {detail: {respuestasOpciones: p, id: id}}))
      }
    )
  }

  agregarRespuestaPrimerNivelPregunta(id, texto, indice) {
    const validacionExistencia = this.preguntas.map( pg => pg.respuestas.map( re => re.id === id))
      .reduceRight((pre, act) => { return pre || act.includes(true) }, false)
    if (validacionExistencia) {
      dispatchEvent(new CustomEvent('mostrarRespuesta', { detail: { id: id}}))
      dispatchEvent(new CustomEvent('mostrarError', { detail: { error: `Señor asesor, la condición
       medica por usted informada en esta pregunta (${texto}) ya fue diligenciada en la pregunta 1, favor remitirse a 
       la pegunta 1 de la declaración (Enfermedades Generales)`}}))
    } else {
      this.preguntas[indice].respuestas.push(new RespuestaPrimerNivel(id, texto, '', 0, false, []))  // TODO: Se deben agrear valores
      const campo = `preguntasPrimerNivel.${indice}.respuestas`
      const evento = [{object: this.preguntas[indice].respuestas, type: 'splice'}]
      this.dc.nativeElement.notifySplices(campo, evento)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/declaracion/declaracion.component.ts